import { ComponentThemeProps } from "@insite/mobius/globals/baseTheme";

const LayoutCellPresentationPropsDefault: ComponentThemeProps["layoutCell"]["defaultProps"] = {};

export default LayoutCellPresentationPropsDefault;
